import React, { useEffect, useState } from "react";
import Oven from "../../../images/oven_green.svg";
import KgGreen from "../../../images/kg_green.svg";
import KgOrange from "../../../images/dark_orange_kg.svg";
import { useGetPackingSummaryQuery } from "../packing/packingApi";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import Button from "../../../components/shared/buttons/button";
import { useSearchOvenDataQuery } from "../../processing/cooking/cookingApi";
import { format } from "date-fns";
import HumidityModal from "./HumidityModal";

import EditHumidityModal from "./EditHumidityModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
const Humidity = ({ data, setShow, date }) => {
  const { _t } = useTranslator();  
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [editReworkData, setEditReworkData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState(data.type);
  const currentDate = getCurrentDate("YYYY-MM-DD");

  const [tab, setTab] = useState("humidity");
  const [page, setPage] = useState(1);
  const [humidityData, setHumidityData] = useState(data);
  const { data: summaryData } = useGetPackingSummaryQuery({
    tab,
    date,
  });
  const { data: ovenData, isLoading: isOvenLoading, isFetching: isOvenFetching } = useSearchOvenDataQuery({
    date,
    type,
    data_from: "rework",
  });
  useEffect(() => {
    setHumidityData((prev) => ({
      ...prev,
      total_kg:
        data.type === "cheeks" && type === "cheeks"
          ? summaryData?.data?.total_kg_cheeks_in_humidity
          : summaryData?.data?.total_kg_strips_in_humidity,
    }));
  }, [summaryData, data.type, type]);

  const handleEdit = (data) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };
  const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    const utcDate = new Date(dateTime + "Z");

    return format(utcDate, "yyyy-MM-dd/HH:mm");
  };
  const handleEditHumidityData = (data) => {
    setEditReworkData(true);
    setModalMode("editHumidity");
    setSelectedRecord(data);
    setShowModal(true);
  };
  const handleClick = () => {
    setShow(false);
  };
  const handleAddData = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };
  const listItems =
    data.type === "cheeks" && type === "cheeks"
      ? [
        {
          label: _t("total_humid_cheeks_kg", "Total Humid Cheeks Kg"),
          value: summaryData?.data.total_kg_in_humidity,
          icon: Oven,
        },
        {
          label: _t("humidity_kg_cheeks", "KG Cheeks In Humidity"),
          value: summaryData?.data.total_kg_cheeks_in_humidity,
          icon: KgGreen,
        },
        {
          label: _t("humidity_kg_cheeks_trash", "KG Trash Of Cheeks"),
          value: summaryData?.data.total_kg_cheeks_in_trash,
          icon: KgOrange,
        },
      ]
      : [
        {
          label: _t("total_humid_strips_kg", "Total Humid Strips Kg"),
          value: summaryData?.data.total_kg_in_humidity,
          icon: Oven,
        },
        {
          label: _t("humidity_kg_strips", "KG Strips In Humidity"),
          value: summaryData?.data.total_kg_strips_in_humidity,
          icon: KgGreen,
        },
        {
          label: _t("humidity_kg_strips_trash", "KG Trash Of Strips"),
          value: summaryData?.data.total_kg_strips_in_trash,
          icon: KgOrange,
        },
      ];

  const ovenColumns = [
    {
      label: _t("humidity_table_date", "Date"),
      accessor: "date_time_entered",
      cell: ({ value }) => convertToUserTimezone(value),
    },
    {
      label: _t("humidity_table_oven_number", "Oven Number"),
      accessor: "oven",
      cell: ({ value }) => value.name,
    },
    {
      label: _t("humidity_table_time", "Time"),
      accessor: "time_entered",
      cell: ({ value }) => {
        if (!value) return "";
        const dateObj = new Date(value);
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
      },
    },
    {
      label: _t("humidity_table_cart_number", "Carts Number"),
      accessor: "cart_number",
      cell: ({ value }) => value.name,
    },
    {
      label: _t("humidity_table_type", "Type"),
      accessor: "type",
    },
    {
      label: _t("humidity_table_treys_count", "Treys Count"),
      accessor: "treys_count",
    },
    {
      label: _t("humidity_table_status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span className={value === "cooking" ? "cmn_badge inactive" : "cmn_badge"}>
          {value === "cooling_room"
            ? _t("humidity_status_cooling", "Cooling Room")
            : value === "bagged"
              ? _t("humidity_status_completed", "Completed")
              : _t("humidity_status_cooking", "Cooking")}
        </span>
      ),
    },
    {
      label: _t("humidity_table_time_end", "Time End"),
      accessor: "time_end",
      cell: ({ value }) => {
        if (!value) return "";
        const dateObj = new Date(value);
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
      },
    },
    {
      label: _t("humidity_table_fruit_weight", "Fruit Wt"),
      accessor: "cart_weight",
      cell: ({ row }) => {
        const { type, cart_weight, cheeks_cart_weight, strips_cart_weight } = row;
        const formatWeight = (weight) =>
          parseFloat(weight) === 0.0 ? _t("humidity_no_data", "No data yet") : weight;

        if (type === "cheeks") return formatWeight(cheeks_cart_weight ?? _t("humidity_no_data", "No data yet"));
        if (type === "strips") return formatWeight(strips_cart_weight ?? _t("humidity_no_data", "No data yet"));
        if (type === "cheeks/strips") {
          const cheeksWeight = formatWeight(cheeks_cart_weight ?? "0");
          const stripsWeight = formatWeight(strips_cart_weight ?? "0");
          return `${cheeksWeight}/${stripsWeight}`;
        }
        return formatWeight(cart_weight ?? _t("humidity_no_data", "No data yet"));
      },
    },
    {
      label: _t("humidity_table_overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          {row.status === "bagged" ? (
            <span>{formatDateTime(row.updated_at)}</span>
          ) : (
            <Button
              size="small"
              label={
                row.status === "cooling_room"
                  ? _t("humidity_add_data", "Add Data")
                  : _t("humidity_edit", "Edit")
              }
              className={row.status === "cooling_room" ? "borderRedBtn" : ""}
              onClick={
                row.status === "cooling_room"
                  ? () =>
                    handleEditHumidityData({
                      ...row,
                      ...humidityData,
                      ovenDataId: row.id,
                    })
                  : () => handleEdit(row)
              }
            />
          )}
        </>
      ),
    },
  ];

  return (
    <div>
      {addRecord && (
        <HumidityModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
          type_name={type}
          date={date}
        />
      )}
      {editReworkData && (
        <EditHumidityModal
          show={showModal}
          setShow={setEditReworkData}
          mode={modalMode}
          record={selectedRecord}
        />
      )}
      <div className="breadcrumbs d-flex">
        <p onClick={handleClick}>{_t("humidity_breadcrumb_rework", "Rework")} / </p>{" "}
        <span>
          <p className="current"> {_t("humidity_breadcrumb_humidity", "Humidity")} </p>
        </span>
      </div>
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("humidity_overview_title", "Humidity Room Overview")}</h6>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>

      <Datatable
        title={_t("humidity_table_title", "Oven Logs")}
        columns={ovenColumns}
        tableData={ovenData?.data}
        buttons={[
          {
            label: _t("humidity_add_button", "Add Humidity Data"),
            onClick: handleAddData,
            icon: PlusSvg,
          },
        ]}
        showPegination={false}
        page={page}
        showCount={false}
        isLoading={isOvenLoading || isOvenFetching}
      />
    </div>
  );
};

export default Humidity;
